var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomFitting(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 83,
    viewBox: "0 0 29 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2285 27C25.2285 26.5823 24.8899 26.2437 24.4722 26.2437L4.47217 26.2437C4.05446 26.2437 3.71584 26.5823 3.71584 27L3.71584 72.0856C3.71584 77.9764 8.57642 82.7563 14.4722 82.7563C20.3679 82.7563 25.2285 77.9764 25.2285 72.0856L25.2285 27Z",
    fill: "white",
    stroke: "#7D7D7D",
    strokeWidth: 0.487345
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2285 9.21633L0.243567 9.21633L0.243567 22.1445C0.243567 24.4323 2.0982 26.2869 4.386 26.2869L24.0861 26.2869C26.3739 26.2869 28.2285 24.4323 28.2285 22.1445L28.2285 9.21633Z",
    stroke: "#7D7D7D",
    strokeWidth: 0.487345
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4722 78L14.4722 37.3136L14.4722 1",
    stroke: "#016DB0",
    strokeWidth: 0.799071,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "4.79 4.79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65576 14.9888L4.65576 14L9.03271 14L9.03271 14.8438L6.96289 17.063C6.75488 17.2944 6.59082 17.498 6.4707 17.6738C6.35059 17.8525 6.26416 18.0122 6.21143 18.1528C6.15576 18.2964 6.12793 18.4326 6.12793 18.5615C6.12793 18.7549 6.16016 18.9204 6.22461 19.0581C6.28906 19.1987 6.38428 19.3071 6.51025 19.3833C6.6333 19.4595 6.78564 19.4976 6.96729 19.4976C7.16064 19.4976 7.32764 19.4507 7.46826 19.3569C7.60596 19.2632 7.71143 19.1328 7.78467 18.9658C7.85498 18.7988 7.89014 18.6099 7.89014 18.3989L9.16016 18.3989C9.16016 18.7798 9.06934 19.1284 8.8877 19.4448C8.70605 19.7642 8.44971 20.0176 8.11865 20.2051C7.7876 20.3955 7.39502 20.4907 6.94092 20.4907C6.49268 20.4907 6.11475 20.4175 5.80713 20.271C5.49658 20.1274 5.26221 19.9194 5.104 19.647C4.94287 19.3774 4.8623 19.0552 4.8623 18.6802C4.8623 18.4692 4.896 18.2627 4.96338 18.0605C5.03076 17.8613 5.12744 17.6621 5.25342 17.4629C5.37646 17.2666 5.52588 17.0674 5.70166 16.8652C5.87744 16.6631 6.07227 16.4536 6.28613 16.2368L7.39795 14.9888L4.65576 14.9888Z",
    fill: "#1F1F1F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomFitting);
export default __webpack_public_path__ + "static/media/bottom-fitting.858392aa1d423eedd44c93e8e53bfb1d.svg";
export { ForwardRef as ReactComponent };